import React, { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';

const wrapperSx = {
    '@media print': {
        padding: '.6cm',
        overflow: 'hidden'
    }
};

const noPaddingWrapperSx = {
    '@media print': {
        padding: '.1cm',
        overflow: 'hidden'
    }
};

const titleSx = {
    display: 'none',
    textAlign: 'center',
    fontSize: '.7cm',
    '@media print': {
        display: 'block'
    }
};

const ReportPrint = forwardRef(({ children, title, landscape, noPadding }, ref) => {
    return (
        <Box ref={ref} sx={noPadding ? noPaddingWrapperSx : wrapperSx}>
            <style type="text/css" media="print">{landscape && "@page { size: landscape; }"}</style>
            <Typography component="p" sx={titleSx}>{title}</Typography>
            {children}
        </Box>
    );
});

ReportPrint.displayName = 'ReportPrint';

export default ReportPrint;
